let groupedUnits = {
  weight: {
    kg: {
      toSIFactor: 1,
      singular: 'Kilogram',
      plural: 'Kilograms',
    },
    lb: {
      toSIFactor: 1 / 2.20462262185,
      singular: 'Pound',
      plural: 'Pounds',
    },
  },
  area: {
    m2: {
      toSIFactor: 1,
      singular: 'Square Meter',
      plural: 'Square Meters'
    },
    ha: {
      toSIFactor: 1e4,
      singular: 'Hectare',
      plural: 'Hectares',
    },
    ac: {
      toSIFactor: 4046.8564,
      singular: 'Acre',
      plural: 'Acres',
    },
  },
};

class Service {
  convert(groupName, from, to, value) {
    let units = groupedUnits[groupName];
    if (!units) { throw new Error(`Unknown unit group ${groupName}`) }

    let fromUnit = units[from];
    if (!fromUnit) { throw new Error(`Unknown ${groupName} from unit ${from}`); }

    let toUnit = units[to];
    if (!toUnit) { throw new Error(`Unknown ${groupName} to unit ${to}`); }

    return value * (fromUnit.toSIFactor / toUnit.toSIFactor);
  }

  areaFromM2(value, to) { return this.convert('area', 'm2', to, value); }
  areaToM2(value, from) { return this.convert('area', from, 'm2', value); }

  weightFromKg(value, to) { return this.convert('weight', 'kg', to, value); }
  weightToKg(value, from) { return this.convert('weight', from, 'kg', value); }
}

export const UnitConversionService = new Service();



// WEBPACK FOOTER //
// ./src/lib/services/unitConversions.js